import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let tl1, tl2; // Timelines
let initialized = false; // Flag to check if the animation was initialized

function removeClonedContainers() {
  // Remove or hide cloned containers
  const clonedContainers = document.querySelectorAll(".image-container-cloned");
  clonedContainers.forEach(container => container.remove()); // Remove the cloned containers
}

function resetStyles() {
  // Reset the styles of your animated elements to their initial states
  const imageContainers = document.querySelectorAll(".image-container");
  imageContainers.forEach(container => {
    gsap.set(container, { clearProps: "all" }); // Clear GSAP applied styles
  });
}

function cleanUpAnimations() {
  if (tl1 && tl2) {
    tl1.kill(); // Kill the timeline to free up resources
    tl2.kill();
    tl1 = tl2 = null; // Reset timeline references
  }
  resetStyles(); // Reset styles after killing the timelines
  removeClonedContainers(); // Remove cloned containers as part of cleanup
  initialized = false; // Reset initialized flag
}

function createClonedContainer() {
  let imageContainer = document.querySelector(".image-container");
  // Check if cloned container already exists, to prevent duplicates
  if (!document.querySelector(".image-container-cloned")) {
    let clonedContainer = imageContainer.cloneNode(true);
    clonedContainer.classList.add("image-container-cloned"); // Add class for easy selection
    imageContainer.parentNode.appendChild(clonedContainer);
  }
}

function initAnimation() {
  if (window.innerWidth > 768) {
    if (!initialized && document.querySelector(".wf-floating-images") && !document.querySelector("body.wp-admin")) {
      initialized = true; // Set flag to true
      gsap.registerPlugin(ScrollTrigger);
      createClonedContainer(); // Ensure cloned container is created

      let imageContainer = document.querySelector(".image-container");
      let clonedContainer = document.querySelector(".image-container-cloned");
      gsap.set(clonedContainer, { yPercent: 100 });

      const normalSpeed = 15, fastSpeed = 30;

      tl1 = gsap.timeline({ repeat: -1, defaults: { ease: "none" }, paused: true })
        .to(imageContainer, { yPercent: -100, duration: normalSpeed });

      tl2 = gsap.timeline({ repeat: -1, defaults: { ease: "none" }, paused: true })
        .to(clonedContainer, { yPercent: 0, duration: normalSpeed });

      // Adjust speed function and scroll listener remain unchanged

      tl1.play();
      tl2.play();
    }
  } else if (initialized) {
    cleanUpAnimations();
  }
}

// Initial check and resize listener remain unchanged
initAnimation();

window.addEventListener('resize', () => {
  initAnimation(); // This will check and adjust animations as needed on resize
});
